import { render } from "./UnassinedPackageFilter.vue?vue&type=template&id=c61aea8c&ts=true"
import script from "./UnassinedPackageFilter.vue?vue&type=script&lang=ts"
export * from "./UnassinedPackageFilter.vue?vue&type=script&lang=ts"

import "./UnassinedPackageFilter.vue?vue&type=style&index=0&id=c61aea8c&lang=css"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__